if (!customElements.get('product-sticky-bar')) {
  customElements.define(
    'product-sticky-bar',
    class ProductStickyBar extends HTMLElement {
      connectedCallback() {
        this.priceEl = this.querySelector('[data-sticky-price]');
        this.installmentEl = this.querySelector('[data-sticky-installment]');
        this.variantInput = this.querySelector('[data-sticky-variant-id]');
        this.buyButton = this.querySelector('[data-sticky-buy]');
        this.buyText = this.querySelector('[data-sticky-buy-text]');
        this.form = this.querySelector('[data-sticky-form]');
        this.needsInstall = this.dataset.needsInstall === 'true';

        this.form?.addEventListener('submit', (evt) => this.onSubmit(evt));

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => this.onVariantChange(event));
        }

        const target = document.querySelector('.product-form__submit');
        if (!target) {
          this.classList.add('product-sticky-bar--visible');
          return;
        }
        this.observer = new IntersectionObserver(
          ([entry]) => {
            // show once the buy box has scrolled off the top (not while it is below the fold)
            const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            this.classList.toggle('product-sticky-bar--visible', scrolledPast);
          },
          { rootMargin: '-80px 0px 0px 0px' }
        );
        this.observer.observe(target);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        this.unsubscribe?.();
      }

      onVariantChange(event) {
        const variant = event?.data?.variant;
        if (!variant) return;
        const label = [variant.title, ...(variant.options || [])].join(' ').toLowerCase();
        this.needsInstall = label.includes('installed');
        this.dataset.needsInstall = String(this.needsInstall);

        if (this.variantInput) this.variantInput.value = variant.id;
        if (this.priceEl) this.priceEl.textContent = this.formatMoney(variant.price);
        if (this.installmentEl) this.installmentEl.textContent = this.formatMoney(Math.round(variant.price / 4));
        if (this.buyText) {
          this.buyText.textContent = this.needsInstall ? this.dataset.installLabel : this.dataset.buyLabel;
        }
        if (this.buyButton) this.buyButton.toggleAttribute('disabled', !variant.available);
      }

      onSubmit(evt) {
        if (!this.needsInstall) return;
        // the main form holds the two required install fields; send the buyer there
        evt.preventDefault();
        const fields = document.querySelector('[data-install-fields]') || document.querySelector('.product-form__submit');
        fields?.scrollIntoView({ block: 'center', behavior: 'smooth' });
        fields?.querySelector('[data-install-input]')?.focus({ preventScroll: true });
      }

      formatMoney(cents) {
        const amount = cents / 100;
        const whole = Number.isInteger(amount);
        try {
          return new Intl.NumberFormat(undefined, {
            style: 'currency',
            currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD',
            minimumFractionDigits: whole ? 0 : 2,
            maximumFractionDigits: 2,
          }).format(amount);
        } catch (e) {
          return `$${whole ? amount : amount.toFixed(2)}`;
        }
      }
    }
  );
}
